module.exports = __webpack_public_path__ + "static/background-back-gradient-f5d50dc4b50600d72098fafce0f2b388.png";